import React, { useState, useEffect, useCallback } from "react";
import Box from "@mui/material/Box";

import {
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
  Stepper,
  Step,
  StepLabel,
  IconButton,
  Grid,
} from "@mui/material";
import { Check, ExpandMore } from "@mui/icons-material";

import CircularProgress from "@mui/material/CircularProgress";

import { styled, alpha } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";

import { ReactComponent as IconFile } from "../../images/iconFile.svg";
import { ReactComponent as IconUserMulti } from "../../images/iconUserMulti.svg";

import AnamneseNeurologica from "../ResumoConsulta/modulosReadOnly/AnamneseNeurologica";
import ExameNeurologico from "../ResumoConsulta/modulosReadOnly/Exameneurologico";
import AnamneseGeral from "../ResumoConsulta/modulosReadOnly/AnamneseGeral";
import ClassificacaoELA from "../ResumoConsulta/modulosReadOnly/ClassificacaoELA";
import PrescricaoMedicamentos from "../ResumoConsulta/modulosReadOnly/PrescricaoMedicamentos";
import Condutas from "../ResumoConsulta/modulosReadOnly/Condutas";
import { dadosIniciais } from "../ResumoConsulta/dadosIniciais";
import ExibirMedicamentosSalvos from "../ResumoConsulta/exibirMedicamentosSalvos";
import ExibirRespostasSalvas from "../ResumoConsulta/exibirRespostasSalvas";

import ExamesProcedimentos from "../PrimeiraConsulta/modulos/Examesprocedimentos";
import "../ResumoConsulta/styles.css";

import CardPaciente from "../../components/CardPaciente";

import { useParams, useNavigate } from "react-router-dom";

import ButtonGoBack from "../../components/Buttons/outlinedGoback";
import api from "../../services/api";
import { getItemDecrypt } from "../../utils/cryptoData";
import dayjs from "dayjs";
import {
  examesPredefinidosList,
  examesPredefinidosOptions,
} from "../PrimeiraConsulta/dadosIniciais";
import ModalDialogs from "../../components/ModalDialogs";

function StepIcon(props) {
  const { completed = false, type = 1, onClick = () => {} } = props;

  const color = {
    4: "#A254DF",
    5: "#65C94D",
    6: "#7AABC5",
    2: "#FE9647",
    3: "#D85050",
  };

  return (
    <IconButton
      onClick={() => onClick()}
      sx={{
        width: 80,
        height: 80,
        padding: 1,
        backgroundColor: completed ? "#C8ECC7" : "#D3E3EB",
        zIndex: 1,
        color: color[type],
        "&:hover": {
          backgroundColor: alpha(color[type], 0.4),
        },
      }}
    >
      <Avatar
        sx={{
          bgcolor: color[type],
          color: "#fff",
          width: "100%",
          height: "100%",
          "& path": {
            stroke: "#fff",
          },
          cursor: "pointer",
        }}
      >
        {completed ? (
          <Check fontSize="large" sx={{ color: "white" }} />
        ) : (
          <IconUserMulti
            width="40px"
            height="40px"
            color="#fff !important"
            stroke="#fff !important"
            path="#fff"
          />
        )}
      </Avatar>
    </IconButton>
  );
}
const ColorlibConnector = styled(StepConnector)(
  ({ theme, currentProgress }) => ({
    left: "calc(-50% + 60px)",
    right: "calc(50% + 60px)",
    [`&.${stepConnectorClasses.active}:last-of-type::before`]: {
      content: `"${currentProgress}%"`,
      position: "absolute",
      top: "-17px",
      left: "calc(50% - 17px)",
      fontSize: "18px",
      fontWeight: "600",
      lineHeight: "24.55px",
      color: "#737373",
    },

    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 28,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: "#3AB238",
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: "#3AB238",
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 2,
      border: 0,
      backgroundColor: "#999999",
      borderRadius: 1,
    },
  })
);

const styles = {
  title: {
    fontWeight: "600",
    fontSize: "26px",
    lineHeight: "35px",
    marginBottom: "5px",
    marginTop: "10px",
    color: "#063F5E",
    fontFamily: "Ninuto, sans-serif !important",
  },
  subtitle: {
    fontWeight: "500",
    fontSize: "22px",
    lineHeight: "30px",
    marginBottom: "15px",
    color: "#1E729F",
  },
};
export default function ProgressoMultidisciplinar() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [data, setData] = useState(dadosIniciais);
  const [tabAnamnese, setTabAnamnese] = useState(0);
  const [isLoaging, setIsLoagind] = useState(false);
  const [tabExameNeurologico, setTabExameNeurologico] = useState(0);
  const [medicamentosSalvos, setMedicamentosSalvos] = useState([]);
  const [tabExamesProcedimentos, setTabExamesProcedimentos] = useState(0);

  const [consulta, setConsulta] = useState(null);
  const [selectedStep, setSelectedStep] = useState(null);
  const [isAppointmentInProgress, setIsAppointmentInProgress] = useState(false);

  const vinculo = getItemDecrypt("vinculo_ativo");

  useEffect(() => {
    getConsultaAgendada(id);
  }, [id]);

  const handleSelectedStep = (item) => {
    setSelectedStep(item);
    if (item.status === 3) {
      fetchAll(item.id_consultas_evoloucao);
    }
  };

  const fetchAll = async (id) => {
    setIsLoagind(true);
    try {
      await Promise.all([
        getMedicamentosConsulta(id),
        getRespostasConsulta(id, consulta.id),
      ]);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    } finally {
      setIsLoagind(false);
    }
  };

  const getConsultaAgendada = async (id) => {
    try {
      const { data } = await api.get(`agenda-paciente/${id}`, {
        params: {
          is_paciente: true,
          status: "2",
          data: dayjs().format("YYYY-MM-DD"),
        },
      });

      if (data.length > 0) {
        setConsulta(data[0]);
      } else {
        setIsAppointmentInProgress(true);
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  };

  const getRespostasOutherExams = async (idConsultaEvolucao) => {
    if (!idConsultaEvolucao || idConsultaEvolucao === "") {
      return {};
    }
    const response = await api.get(`/outros-exames/${idConsultaEvolucao}`);
    if (response.data) {
      const solicitacaoOutrosExames = response.data.map((item) => {
        return {
          tipoExame: item.no_tipo_exame,
          modeloExame: item.no_modelo_exame,
          descricaoSolicitacaoExame: item.no_descricao_exame.replace(
            /\r\n|\r/g,
            "\n"
          ),
        };
      });
      return {
        solicitacaoOutrosExames: solicitacaoOutrosExames,
      };
    }
    return {};
  };

  async function getExamesConsulta(id_consulta_evolucao) {
    try {
      const { data } = await api.post(`exames-consulta/`, {
        id_consulta_evolucao: id_consulta_evolucao,
      });

      if (data.length !== 0) {
        const examesIDS = data[0].exams.map((exame) => `${exame.idExame}`);
        dadosIniciais.examesPredefinidosExamesEProcedimentos = examesIDS;
        dadosIniciais.examesLaboratoriaisObservacao = data[0].observacao;
        return {
          examesPredefinidosExamesEProcedimentos: examesIDS,
          examesLaboratoriaisObservacao: data[0].observacao,
        };
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
      return {};
    }
    return {};
  }

  async function getMedicamentosConsulta(id_consulta_evolucao) {
    try {
      const { data } = await api.post(`medicamentos-consulta/`, {
        id_consulta_evolucao: id_consulta_evolucao,
      });

      if (data.length !== 0) {
        const medicamentos = ExibirMedicamentosSalvos(data);
        setMedicamentosSalvos(medicamentos);
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }
  async function getRespostasConsulta(id_consulta_evolucao, id_consulta) {
    try {
      const [response1, response2, response3, response4] = await Promise.all([
        api.post("respostas-consulta", {
          id_consulta_evolucao: id_consulta_evolucao,
        }),
        api.get(`anaminese/${id_consulta}/`),
        getRespostasOutherExams(id_consulta_evolucao),
        getExamesConsulta(id_consulta_evolucao),
      ]);

      const respostasCombinadas = [
        ...response1.data,
        ...response2.data.respostas,
      ];

      ExibirRespostasSalvas(respostasCombinadas, dadosIniciais);

      setData({
        ...dadosIniciais,
        ...response3,
        ...response4,
      });
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const getStatus = useCallback((status) => {
    switch (status) {
      case 1:
        return {
          color: "#063f5e",
          label: "Consulta Agendada",
        };
      case 2:
        return {
          color: "#FE9647",
          label: "Consulta em andamento",
        };
      case 3:
        return {
          color: "#65C94D",
          label: "Consulta finalizada!",
        };
      case 4:
        return {
          color: "#D85050",
          label: "Consulta Cancelada",
        };
      default:
        return {
          color: "#063f5e",
          label: "Consulta Agendada",
        };
    }
  }, []);

  function handleRedirectProntuario() {
    navigate(`/pacientes/prontuario/${id}`);
  }

  const steps = React.useMemo(() => {
    let stepsTemp = [];
    let progresso = 0;
    if (consulta === null) return stepsTemp;
    stepsTemp = consulta?.consultas_evoloucao?.map((item) => {
      if (item.id_status === 3 || item.id_status === 4) {
        progresso++;
      }
      return {
        id_consultas_evoloucao: item.co_id,
        perfil_id: item.perfil.id,
        perfil_desc: item.perfil.descricao,
        name: item.usuario.nome,
        status: item.id_status,
        id_vinculo: item.id_vinculo,
        estabelecimento: item.estabelecimento.fantasia,
      };
    });
    if (stepsTemp.length > 0) {
      stepsTemp.sort((a, b) => {
        const orderStatus = [3, 4, 2, 1];
        const orderPerfilId = [4, 5, 6, 2, 3];

        if (a.status !== b.status) {
          return orderStatus.indexOf(a.status) - orderStatus.indexOf(b.status);
        } else {
          return (
            orderPerfilId.indexOf(a.perfil_id) -
            orderPerfilId.indexOf(b.perfil_id)
          );
        }
      });
    }
    setProgress(progresso);
    return stepsTemp;
  }, [consulta]);

  return (
    <Box sx={{ mb: 10 }}>
      <Box id="resumoConsulta">
        <ButtonGoBack />
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box style={styles.title}>Consulta</Box>
        </Box>

        <CardPaciente id={id} />
        {consulta && (
          <Box
            sx={{
              boxShadow: "0px 1px 8px 0px #00000026",
              boxSizing: "border-box !important",
              padding: "30px 24px",
              margin: "16px 0px",
              borderRadius: "8px",
              width: "100%",
            }}
          >
            <Typography style={styles.subtitle} mb={2}>
              Progresso Multidisciplinar
            </Typography>

            {steps.length > 0 && (
              <Stack
                sx={{
                  width: "100%",
                  backgroundColor: "#EFF5F7",
                  borderRadius: "8px",
                  padding: "16px 8px",
                }}
                spacing={4}
              >
                <Stepper
                  alternativeLabel
                  activeStep={progress}
                  connector={
                    <ColorlibConnector
                      currentProgress={(
                        (100 / steps.length) *
                        progress
                      ).toFixed(2)}
                    />
                  }
                >
                  {steps.map((item) => (
                    <Step key={item.id_consultas_evolouca}>
                      <StepLabel
                        StepIconComponent={(props) => (
                          <StepIcon
                            {...props}
                            type={item.perfil_id}
                            onClick={() => handleSelectedStep(item)}
                          />
                        )}
                      >
                        {item.perfil_desc} <br />
                        <Typography
                          component="span"
                          variant="caption"
                          style={{
                            fontWeight: "700",
                            color: getStatus(item?.status).color,
                            textAlign: "center",
                          }}
                        >
                          {getStatus(item?.status).label}
                        </Typography>
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
                <Typography
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    lineHeight: "24px",
                    color: getStatus(consulta?.status).color,
                    textAlign: "center",
                  }}
                >
                  {getStatus(consulta?.status).label}
                </Typography>
              </Stack>
            )}

            <Stack mt={3} mb={3}>
              {consulta && selectedStep && (
                <Box
                  sx={{
                    boxShadow: "0px 1px 8px 0px #00000026",
                    boxSizing: "border-box !important",
                    padding: "16px 16px",
                    margin: "16px 0px",
                    borderRadius: "8px",
                    width: "100%",
                  }}
                >
                  <Typography style={styles.subtitle} mb={2}>
                    Detalhe da consulta selecionada:
                  </Typography>
                  <Grid className="template-grid column-3">
                    {selectedStep && (
                      <Grid item key={selectedStep.id_vinculo}>
                        <Typography className="item-text label color-blue-dark">
                          <Stack direction="row" alignItems="center" gap={1}>
                            Profissional de Saude:
                          </Stack>
                        </Typography>
                        <Typography mb="15px" className="item-text color-gray">
                          {selectedStep.name} <br />
                          {selectedStep.estabelecimento}
                        </Typography>
                      </Grid>
                    )}
                    <Grid item>
                      <Typography className="item-text label color-blue-dark">
                        Data da consulta:
                      </Typography>
                      <Typography mb="15px" className="item-text color-gray">
                        {dayjs(consulta.data_consulta)
                          .locale("pt-br")
                          .format("dddd, D [de] MMMM [de] YYYY")}{" "}
                        ás {consulta.inicio}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography className="item-text label color-blue-dark">
                        Estabelecimento:
                      </Typography>
                      <Typography mb="15px" className="item-text color-gray">
                        {consulta.estabelecimento.nome}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              )}
              {isLoaging ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  {selectedStep && selectedStep.status === 3 && (
                    <>
                      <AnamneseGeral data={data} small />
                      {selectedStep?.perfil_id === 4 ? (
                        <>
                          <AnamneseNeurologica
                            tabValue={tabAnamnese}
                            tabOnChange={(e, value) => setTabAnamnese(value)}
                            data={data}
                            small
                          />
                          <ExameNeurologico
                            tabValue={tabExameNeurologico}
                            tabOnChange={(e, value) =>
                              setTabExameNeurologico(value)
                            }
                            data={data}
                            small
                          />
                          <ExamesProcedimentos
                            examesPredefinidosOptions={
                              examesPredefinidosOptions
                            }
                            examesPredefinidosList={examesPredefinidosList}
                            readOnly
                            small
                            data={data}
                            setData={() => {}}
                            value={tabExamesProcedimentos}
                            handleChange={(e, value) =>
                              setTabExamesProcedimentos(value)
                            }
                          />

                          <ClassificacaoELA data={data} small />

                          <PrescricaoMedicamentos
                            data={medicamentosSalvos}
                            small
                          />
                        </>
                      ) : (
                        <>
                          <Accordion
                            defaultExpanded={false}
                            className="AccordionContainer"
                          >
                            <AccordionSummary
                              expandIcon={
                                <ExpandMore style={{ color: "#1E729F" }} />
                              }
                              aria-controls="ExameNeurologico-content"
                              id="ExameNeurologico-header"
                              className="AccordionSummaryContainer small"
                            >
                              <Stack
                                direction="row"
                                alignItems="center"
                                gap="8px "
                                height="30px"
                              >
                                <IconFile style={{ width: "24px" }} />
                                <Typography className="Accordion_title small">
                                  Avaliação/Reavaliação
                                </Typography>
                              </Stack>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography className="item-text label color-blue-dark">
                                Anamnese
                              </Typography>
                              <Typography
                                mb="15px"
                                className="item-text color-gray"
                              >
                                {data?.anamnese ?? ""}
                              </Typography>

                              <Typography className="item-text label color-blue-dark">
                                Sintomas e queixas
                              </Typography>
                              <Typography
                                mb="15px"
                                className="item-text color-gray"
                              >
                                {data?.sintomasEQueixas ?? ""}
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <ExamesProcedimentos
                            examesPredefinidosOptions={
                              examesPredefinidosOptions
                            }
                            examesPredefinidosList={examesPredefinidosList}
                            readOnly
                            small
                            data={data}
                            setData={() => {}}
                            value={tabExamesProcedimentos}
                            handleChange={(e, value) =>
                              setTabExamesProcedimentos(value)
                            }
                          />
                        </>
                      )}
                      <Condutas data={data} small />
                    </>
                  )}
                </>
              )}
            </Stack>
          </Box>
        )}
      </Box>
      <ModalDialogs
        open={isAppointmentInProgress}
        onClose={handleRedirectProntuario}
        title="Aviso"
        body={`Não há consulta multidisciplinar em andamento para este paciente. 
          Você será redirecionado para o prontuário do paciente.`}
        onActionPrimary={handleRedirectProntuario}
        primaryButtonText="Prontuário"
        modalType="warning"
      />
    </Box>
  );
}
